import styled from 'styled-components';

import Heading, { HeadingProps } from '../Heading';

export type H4Props = Omit<HeadingProps, 'tagName'>;

const H4 = styled(Heading).attrs({
  tagName: 'h4',
})``;

H4.displayName = 'H4';

export default H4;
